import React from 'react';
import { useParams } from 'react-router-dom';
import Header from './Header.js';
import LineChart from './LineChart.js';
import DataTable from './DataTable.js';
import { getArticle } from './DataContextProvider.js';
import ArticleInfo from './ArticleInfo.js';

export default function ArticleDashboard({ withSplits }) {
  const [article, setArticle] = React.useState({});
  const { id } = useParams();
  const apiBase = process.env.NODE_ENV === 'development' ? 'http://localhost:5000' : '';
  
  let title = (id ? '' : 'Articles');
  let filters = {};
  let translationFilters;
  if (id) {
    filters = {articles: [id]};
    translationFilters = {articles: article.translations, splitTranslations: true};
  }

  React.useEffect(() => {
    if (id) {
      getArticle(id).then(data => {
        setArticle(data);
        if (data.title || data.slug) {
          document.title = (data.title || data.slug) + ' - Twilio Blogalytics';
        }
      });
    }
  }, [id]);

  const addRedirect = (id, flag, item) => {
    return (
      <>
        {item}
        &nbsp;
        {flag && <><img alt="" src="/sendgrid.png" />&nbsp;</>}
        <a target="_blank" rel="noreferrer" href={apiBase + `/api/articles/${id}/redirect`}><img alt="" src="/external-link.svg" className="link" /></a>
      </>
    );
  };

  return (
    <>
      <Header title={title} location="/" skipPageTitle={!!id} />
      {id &&
        <ArticleInfo article={article} />
      }
      <LineChart filters={filters} withTotals={true} withSplits={withSplits} />
      {id ?
        <>
          {article.translations !== undefined && article.translations.length > 0 &&
            <DataTable item="articles" title="Translations" filters={translationFilters} paginate={false} extra={addRedirect} />
          }
        </>
      :
        <DataTable item="articles" title="Article" filters={filters} paginate={true} extra={addRedirect} />
      }
    </>
  );
}
